export const items = [];

const locations = {
  "n": [
    {
      "des": "北部",
      "no": "1",
      "n": [
        {
          "des": "台北市",
          "no": "100100",
          "n": [
            {
              "des": "中正區",
              "no": "100101"
            },
            {
              "des": "大同區",
              "no": "100102"
            },
            {
              "des": "中山區",
              "no": "100103"
            },
            {
              "des": "松山區",
              "no": "100104"
            },
            {
              "des": "大安區",
              "no": "100105"
            },
            {
              "des": "萬華區",
              "no": "100106"
            },
            {
              "des": "信義區",
              "no": "100107"
            },
            {
              "des": "士林區",
              "no": "100108"
            },
            {
              "des": "北投區",
              "no": "100109"
            },
            {
              "des": "內湖區",
              "no": "100110"
            },
            {
              "des": "南港區",
              "no": "100111"
            },
            {
              "des": "文山區",
              "no": "100112"
            }
          ]
        },
        {
          "des": "新北市",
          "no": "100200",
          "n": [
            {
              "des": "萬里區",
              "no": "100201"
            },
            {
              "des": "金山區",
              "no": "100202"
            },
            {
              "des": "板橋區",
              "no": "100203"
            },
            {
              "des": "汐止區",
              "no": "100204"
            },
            {
              "des": "深坑區",
              "no": "100205"
            },
            {
              "des": "石碇區",
              "no": "100206"
            },
            {
              "des": "瑞芳區",
              "no": "100207"
            },
            {
              "des": "平溪區",
              "no": "100208"
            },
            {
              "des": "雙溪區",
              "no": "100209"
            },
            {
              "des": "貢寮區",
              "no": "100210"
            },
            {
              "des": "新店區",
              "no": "100211"
            },
            {
              "des": "坪林區",
              "no": "100212"
            },
            {
              "des": "烏來區",
              "no": "100213"
            },
            {
              "des": "永和區",
              "no": "100214"
            },
            {
              "des": "中和區",
              "no": "100215"
            },
            {
              "des": "土城區",
              "no": "100216"
            },
            {
              "des": "三峽區",
              "no": "100217"
            },
            {
              "des": "樹林區",
              "no": "100218"
            },
            {
              "des": "鶯歌區",
              "no": "100219"
            },
            {
              "des": "三重區",
              "no": "100220"
            },
            {
              "des": "新莊區",
              "no": "100221"
            },
            {
              "des": "泰山區",
              "no": "100222"
            },
            {
              "des": "林口區",
              "no": "100223"
            },
            {
              "des": "蘆洲區",
              "no": "100224"
            },
            {
              "des": "五股區",
              "no": "100225"
            },
            {
              "des": "八里區",
              "no": "100226"
            },
            {
              "des": "淡水區",
              "no": "100227"
            },
            {
              "des": "三芝區",
              "no": "100228"
            },
            {
              "des": "石門區",
              "no": "100229"
            }
          ]
        },
        {
          "des": "基隆市",
          "no": "100300",
          "n": [
            {
              "des": "仁愛區",
              "no": "100301"
            },
            {
              "des": "信義區",
              "no": "100302"
            },
            {
              "des": "中正區",
              "no": "100303"
            },
            {
              "des": "中山區",
              "no": "100304"
            },
            {
              "des": "安樂區",
              "no": "100305"
            },
            {
              "des": "暖暖區",
              "no": "100306"
            },
            {
              "des": "七堵區",
              "no": "100307"
            }
          ]
        },
        {
          "des": "桃園市",
          "no": "100500",
          "n": [
            {
              "des": "中壢區",
              "no": "100501"
            },
            {
              "des": "平鎮區",
              "no": "100502"
            },
            {
              "des": "龍潭區",
              "no": "100503"
            },
            {
              "des": "楊梅區",
              "no": "100504"
            },
            {
              "des": "新屋區",
              "no": "100505"
            },
            {
              "des": "觀音區",
              "no": "100506"
            },
            {
              "des": "桃園區",
              "no": "100507"
            },
            {
              "des": "龜山區",
              "no": "100508"
            },
            {
              "des": "八德區",
              "no": "100509"
            },
            {
              "des": "大溪區",
              "no": "100510"
            },
            {
              "des": "復興區",
              "no": "100511"
            },
            {
              "des": "大園區",
              "no": "100512"
            },
            {
              "des": "蘆竹區",
              "no": "100513"
            }
          ]
        },
        {
          "des": "新竹市",
          "no": "100600",
          "n": [
            {
              "des": "東區",
              "no": "100601"
            },
            {
              "des": "北區",
              "no": "100602"
            },
            {
              "des": "香山區",
              "no": "100603"
            }
          ]
        },
        {
          "des": "新竹縣",
          "no": "100700",
          "n": [
            {
              "des": "竹北市",
              "no": "100701"
            },
            {
              "des": "湖口鄉",
              "no": "100702"
            },
            {
              "des": "新豐鄉",
              "no": "100703"
            },
            {
              "des": "新埔鎮",
              "no": "100704"
            },
            {
              "des": "關西鎮",
              "no": "100705"
            },
            {
              "des": "芎林鄉",
              "no": "100706"
            },
            {
              "des": "寶山鄉",
              "no": "100707"
            },
            {
              "des": "竹東鎮",
              "no": "100708"
            },
            {
              "des": "五峰鄉",
              "no": "100709"
            },
            {
              "des": "橫山鄉",
              "no": "100710"
            },
            {
              "des": "尖石鄉",
              "no": "100711"
            },
            {
              "des": "北埔鄉",
              "no": "100712"
            },
            {
              "des": "峨眉鄉",
              "no": "100713"
            }
          ]
        },
        {
          "des": "苗栗縣",
          "no": "100800",
          "n": [
            {
              "des": "竹南鎮",
              "no": "100801"
            },
            {
              "des": "頭份市",
              "no": "100802"
            },
            {
              "des": "三灣鄉",
              "no": "100803"
            },
            {
              "des": "南庄鄉",
              "no": "100804"
            },
            {
              "des": "獅潭鄉",
              "no": "100805"
            },
            {
              "des": "後龍鎮",
              "no": "100806"
            },
            {
              "des": "通霄鎮",
              "no": "100807"
            },
            {
              "des": "苑裡鎮",
              "no": "100808"
            },
            {
              "des": "苗栗市",
              "no": "100809"
            },
            {
              "des": "造橋鄉",
              "no": "100810"
            },
            {
              "des": "頭屋鄉",
              "no": "100811"
            },
            {
              "des": "公館鄉",
              "no": "100812"
            },
            {
              "des": "大湖鄉",
              "no": "100813"
            },
            {
              "des": "泰安鄉",
              "no": "100814"
            },
            {
              "des": "銅鑼鄉",
              "no": "100815"
            },
            {
              "des": "三義鄉",
              "no": "100816"
            },
            {
              "des": "西湖鄉",
              "no": "100817"
            },
            {
              "des": "卓蘭鎮",
              "no": "100818"
            }
          ]
        }
      ]
    },
    {
      "des": "中部",
      "no": "2",
      "n": [
        {
          "des": "台中市",
          "no": "100900",
          "n": [
            {
              "des": "中區",
              "no": "100901"
            },
            {
              "des": "東區",
              "no": "100902"
            },
            {
              "des": "南區",
              "no": "100903"
            },
            {
              "des": "西區",
              "no": "100904"
            },
            {
              "des": "北區",
              "no": "100905"
            },
            {
              "des": "北屯區",
              "no": "100906"
            },
            {
              "des": "西屯區",
              "no": "100907"
            },
            {
              "des": "南屯區",
              "no": "100908"
            },
            {
              "des": "太平區",
              "no": "100909"
            },
            {
              "des": "大里區",
              "no": "100910"
            },
            {
              "des": "霧峰區",
              "no": "100911"
            },
            {
              "des": "烏日區",
              "no": "100912"
            },
            {
              "des": "豐原區",
              "no": "100913"
            },
            {
              "des": "后里區",
              "no": "100914"
            },
            {
              "des": "石岡區",
              "no": "100915"
            },
            {
              "des": "東勢區",
              "no": "100916"
            },
            {
              "des": "和平區",
              "no": "100917"
            },
            {
              "des": "新社區",
              "no": "100918"
            },
            {
              "des": "潭子區",
              "no": "100919"
            },
            {
              "des": "大雅區",
              "no": "100920"
            },
            {
              "des": "神岡區",
              "no": "100921"
            },
            {
              "des": "大肚區",
              "no": "100922"
            },
            {
              "des": "沙鹿區",
              "no": "100923"
            },
            {
              "des": "龍井區",
              "no": "100924"
            },
            {
              "des": "梧棲區",
              "no": "100925"
            },
            {
              "des": "清水區",
              "no": "100926"
            },
            {
              "des": "大甲區",
              "no": "100927"
            },
            {
              "des": "外埔區",
              "no": "100928"
            },
            {
              "des": "大安區",
              "no": "100929"
            }
          ]
        },
        {
          "des": "南投縣",
          "no": "101100",
          "n": [
            {
              "des": "南投市",
              "no": "101101"
            },
            {
              "des": "中寮鄉",
              "no": "101102"
            },
            {
              "des": "草屯鎮",
              "no": "101103"
            },
            {
              "des": "國姓鄉",
              "no": "101104"
            },
            {
              "des": "埔里鎮",
              "no": "101105"
            },
            {
              "des": "仁愛鄉",
              "no": "101106"
            },
            {
              "des": "名間鄉",
              "no": "101107"
            },
            {
              "des": "集集鎮",
              "no": "101108"
            },
            {
              "des": "水里鄉",
              "no": "101109"
            },
            {
              "des": "魚池鄉",
              "no": "101110"
            },
            {
              "des": "信義鄉",
              "no": "101111"
            },
            {
              "des": "竹山鎮",
              "no": "101112"
            },
            {
              "des": "鹿谷鄉",
              "no": "101113"
            }
          ]
        },
        {
          "des": "彰化縣",
          "no": "101200",
          "n": [
            {
              "des": "彰化市",
              "no": "101201"
            },
            {
              "des": "芬園鄉",
              "no": "101202"
            },
            {
              "des": "花壇鄉",
              "no": "101203"
            },
            {
              "des": "秀水鄉",
              "no": "101204"
            },
            {
              "des": "鹿港鎮",
              "no": "101205"
            },
            {
              "des": "福興鄉",
              "no": "101206"
            },
            {
              "des": "線西鄉",
              "no": "101207"
            },
            {
              "des": "和美鎮",
              "no": "101208"
            },
            {
              "des": "伸港鄉",
              "no": "101209"
            },
            {
              "des": "員林市",
              "no": "101210"
            },
            {
              "des": "社頭鄉",
              "no": "101211"
            },
            {
              "des": "永靖鄉",
              "no": "101212"
            },
            {
              "des": "埔心鄉",
              "no": "101213"
            },
            {
              "des": "溪湖鎮",
              "no": "101214"
            },
            {
              "des": "大村鄉",
              "no": "101215"
            },
            {
              "des": "埔鹽鄉",
              "no": "101216"
            },
            {
              "des": "田中鎮",
              "no": "101217"
            },
            {
              "des": "北斗鎮",
              "no": "101218"
            },
            {
              "des": "田尾鄉",
              "no": "101219"
            },
            {
              "des": "埤頭鄉",
              "no": "101220"
            },
            {
              "des": "溪州鄉",
              "no": "101221"
            },
            {
              "des": "竹塘鄉",
              "no": "101222"
            },
            {
              "des": "二林鎮",
              "no": "101223"
            },
            {
              "des": "大城鄉",
              "no": "101224"
            },
            {
              "des": "芳苑鄉",
              "no": "101225"
            },
            {
              "des": "二水鄉",
              "no": "101226"
            }
          ]
        },
        {
          "des": "雲林縣",
          "no": "101300",
          "n": [
            {
              "des": "斗南鎮",
              "no": "101301"
            },
            {
              "des": "大埤鄉",
              "no": "101302"
            },
            {
              "des": "虎尾鎮",
              "no": "101303"
            },
            {
              "des": "土庫鎮",
              "no": "101304"
            },
            {
              "des": "褒忠鄉",
              "no": "101305"
            },
            {
              "des": "東勢鄉",
              "no": "101306"
            },
            {
              "des": "台西鄉",
              "no": "101307"
            },
            {
              "des": "崙背鄉",
              "no": "101308"
            },
            {
              "des": "麥寮鄉",
              "no": "101309"
            },
            {
              "des": "斗六市",
              "no": "101310"
            },
            {
              "des": "林內鄉",
              "no": "101311"
            },
            {
              "des": "古坑鄉",
              "no": "101312"
            },
            {
              "des": "莿桐鄉",
              "no": "101313"
            },
            {
              "des": "西螺鎮",
              "no": "101314"
            },
            {
              "des": "二崙鄉",
              "no": "101315"
            },
            {
              "des": "北港鎮",
              "no": "101316"
            },
            {
              "des": "水林鄉",
              "no": "101317"
            },
            {
              "des": "口湖鄉",
              "no": "101318"
            },
            {
              "des": "四湖鄉",
              "no": "101319"
            },
            {
              "des": "元長鄉",
              "no": "101320"
            }
          ]
        }
      ]
    },
    {
      "des": "南部",
      "no": "3",
      "n": [
        {
          "des": "嘉義市",
          "no": "101400",
          "n": [
            {
              "des": "東區",
              "no": "101401"
            },
            {
              "des": "西區",
              "no": "101402"
            }
          ]
        },
        {
          "des": "嘉義縣",
          "no": "101500",
          "n": [
            {
              "des": "番路鄉",
              "no": "101501"
            },
            {
              "des": "梅山鄉",
              "no": "101502"
            },
            {
              "des": "竹崎鄉",
              "no": "101503"
            },
            {
              "des": "阿里山鄉",
              "no": "101504"
            },
            {
              "des": "中埔鄉",
              "no": "101505"
            },
            {
              "des": "大埔鄉",
              "no": "101506"
            },
            {
              "des": "水上鄉",
              "no": "101507"
            },
            {
              "des": "鹿草鄉",
              "no": "101508"
            },
            {
              "des": "太保市",
              "no": "101509"
            },
            {
              "des": "朴子市",
              "no": "101510"
            },
            {
              "des": "東石鄉",
              "no": "101511"
            },
            {
              "des": "六腳鄉",
              "no": "101512"
            },
            {
              "des": "新港鄉",
              "no": "101513"
            },
            {
              "des": "民雄鄉",
              "no": "101514"
            },
            {
              "des": "大林鎮",
              "no": "101515"
            },
            {
              "des": "溪口鄉",
              "no": "101516"
            },
            {
              "des": "義竹鄉",
              "no": "101517"
            },
            {
              "des": "布袋鎮",
              "no": "101518"
            }
          ]
        },
        {
          "des": "台南市",
          "no": "101600",
          "n": [
            {
              "des": "中西區",
              "no": "101601"
            },
            {
              "des": "東區",
              "no": "101602"
            },
            {
              "des": "南區",
              "no": "101603"
            },
            {
              "des": "北區",
              "no": "101604"
            },
            {
              "des": "安平區",
              "no": "101605"
            },
            {
              "des": "安南區",
              "no": "101606"
            },
            {
              "des": "永康區",
              "no": "101607"
            },
            {
              "des": "歸仁區",
              "no": "101608"
            },
            {
              "des": "新化區",
              "no": "101609"
            },
            {
              "des": "左鎮區",
              "no": "101610"
            },
            {
              "des": "玉井區",
              "no": "101611"
            },
            {
              "des": "楠西區",
              "no": "101612"
            },
            {
              "des": "南化區",
              "no": "101613"
            },
            {
              "des": "仁德區",
              "no": "101614"
            },
            {
              "des": "關廟區",
              "no": "101615"
            },
            {
              "des": "龍崎區",
              "no": "101616"
            },
            {
              "des": "官田區",
              "no": "101617"
            },
            {
              "des": "麻豆區",
              "no": "101618"
            },
            {
              "des": "佳里區",
              "no": "101619"
            },
            {
              "des": "西港區",
              "no": "101620"
            },
            {
              "des": "七股區",
              "no": "101621"
            },
            {
              "des": "將軍區",
              "no": "101622"
            },
            {
              "des": "學甲區",
              "no": "101623"
            },
            {
              "des": "北門區",
              "no": "101624"
            },
            {
              "des": "新營區",
              "no": "101625"
            },
            {
              "des": "後壁區",
              "no": "101626"
            },
            {
              "des": "白河區",
              "no": "101627"
            },
            {
              "des": "東山區",
              "no": "101628"
            },
            {
              "des": "六甲區",
              "no": "101629"
            },
            {
              "des": "下營區",
              "no": "101630"
            },
            {
              "des": "柳營區",
              "no": "101631"
            },
            {
              "des": "鹽水區",
              "no": "101632"
            },
            {
              "des": "善化區",
              "no": "101633"
            },
            {
              "des": "大內區",
              "no": "101634"
            },
            {
              "des": "山上區",
              "no": "101635"
            },
            {
              "des": "新市區",
              "no": "101636"
            },
            {
              "des": "安定區",
              "no": "101637"
            }
          ]
        },
        {
          "des": "高雄市",
          "no": "101800",
          "n": [
            {
              "des": "新興區",
              "no": "101801"
            },
            {
              "des": "前金區",
              "no": "101802"
            },
            {
              "des": "苓雅區",
              "no": "101803"
            },
            {
              "des": "鹽埕區",
              "no": "101804"
            },
            {
              "des": "鼓山區",
              "no": "101805"
            },
            {
              "des": "旗津區",
              "no": "101806"
            },
            {
              "des": "前鎮區",
              "no": "101807"
            },
            {
              "des": "三民區",
              "no": "101808"
            },
            {
              "des": "楠梓區",
              "no": "101809"
            },
            {
              "des": "小港區",
              "no": "101810"
            },
            {
              "des": "左營區",
              "no": "101811"
            },
            {
              "des": "仁武區",
              "no": "101812"
            },
            {
              "des": "大社區",
              "no": "101813"
            },
            {
              "des": "岡山區",
              "no": "101814"
            },
            {
              "des": "路竹區",
              "no": "101815"
            },
            {
              "des": "阿蓮區",
              "no": "101816"
            },
            {
              "des": "田寮區",
              "no": "101817"
            },
            {
              "des": "燕巢區",
              "no": "101818"
            },
            {
              "des": "橋頭區",
              "no": "101819"
            },
            {
              "des": "梓官區",
              "no": "101820"
            },
            {
              "des": "彌陀區",
              "no": "101821"
            },
            {
              "des": "永安區",
              "no": "101822"
            },
            {
              "des": "湖內區",
              "no": "101823"
            },
            {
              "des": "鳳山區",
              "no": "101824"
            },
            {
              "des": "大寮區",
              "no": "101825"
            },
            {
              "des": "林園區",
              "no": "101826"
            },
            {
              "des": "鳥松區",
              "no": "101827"
            },
            {
              "des": "大樹區",
              "no": "101828"
            },
            {
              "des": "旗山區",
              "no": "101829"
            },
            {
              "des": "美濃區",
              "no": "101830"
            },
            {
              "des": "六龜區",
              "no": "101831"
            },
            {
              "des": "內門區",
              "no": "101832"
            },
            {
              "des": "杉林區",
              "no": "101833"
            },
            {
              "des": "甲仙區",
              "no": "101834"
            },
            {
              "des": "桃源區",
              "no": "101835"
            },
            {
              "des": "那瑪夏區",
              "no": "101836"
            },
            {
              "des": "茂林區",
              "no": "101837"
            },
            {
              "des": "茄萣區",
              "no": "101838"
            }
          ]
        },
        {
          "des": "屏東縣",
          "no": "102000",
          "n": [
            {
              "des": "屏東市",
              "no": "102001"
            },
            {
              "des": "三地門鄉",
              "no": "102002"
            },
            {
              "des": "霧台鄉",
              "no": "102003"
            },
            {
              "des": "瑪家鄉",
              "no": "102004"
            },
            {
              "des": "九如鄉",
              "no": "102005"
            },
            {
              "des": "里港鄉",
              "no": "102006"
            },
            {
              "des": "高樹鄉",
              "no": "102007"
            },
            {
              "des": "鹽埔鄉",
              "no": "102008"
            },
            {
              "des": "長治鄉",
              "no": "102009"
            },
            {
              "des": "麟洛鄉",
              "no": "102010"
            },
            {
              "des": "竹田鄉",
              "no": "102011"
            },
            {
              "des": "內埔鄉",
              "no": "102012"
            },
            {
              "des": "萬丹鄉",
              "no": "102013"
            },
            {
              "des": "潮州鎮",
              "no": "102014"
            },
            {
              "des": "泰武鄉",
              "no": "102015"
            },
            {
              "des": "來義鄉",
              "no": "102016"
            },
            {
              "des": "萬巒鄉",
              "no": "102017"
            },
            {
              "des": "崁頂鄉",
              "no": "102018"
            },
            {
              "des": "新埤鄉",
              "no": "102019"
            },
            {
              "des": "南州鄉",
              "no": "102020"
            },
            {
              "des": "林邊鄉",
              "no": "102021"
            },
            {
              "des": "東港鎮",
              "no": "102022"
            },
            {
              "des": "琉球鄉",
              "no": "102023"
            },
            {
              "des": "佳冬鄉",
              "no": "102024"
            },
            {
              "des": "新園鄉",
              "no": "102025"
            },
            {
              "des": "枋寮鄉",
              "no": "102026"
            },
            {
              "des": "枋山鄉",
              "no": "102027"
            },
            {
              "des": "春日鄉",
              "no": "102028"
            },
            {
              "des": "獅子鄉",
              "no": "102029"
            },
            {
              "des": "車城鄉",
              "no": "102030"
            },
            {
              "des": "牡丹鄉",
              "no": "102031"
            },
            {
              "des": "恆春鎮",
              "no": "102032"
            },
            {
              "des": "滿州鄉",
              "no": "102033"
            }
          ]
        }
      ]
    },
    {
      "des": "東部",
      "no": "4",
      "n": [
        {
          "des": "宜蘭縣",
          "no": "100400",
          "n": [
            {
              "des": "宜蘭市",
              "no": "100401"
            },
            {
              "des": "頭城鎮",
              "no": "100402"
            },
            {
              "des": "礁溪鄉",
              "no": "100403"
            },
            {
              "des": "壯圍鄉",
              "no": "100404"
            },
            {
              "des": "員山鄉",
              "no": "100405"
            },
            {
              "des": "羅東鎮",
              "no": "100406"
            },
            {
              "des": "三星鄉",
              "no": "100407"
            },
            {
              "des": "大同鄉",
              "no": "100408"
            },
            {
              "des": "五結鄉",
              "no": "100409"
            },
            {
              "des": "冬山鄉",
              "no": "100410"
            },
            {
              "des": "蘇澳鎮",
              "no": "100411"
            },
            {
              "des": "南澳鄉",
              "no": "100412"
            }
          ]
        },
        {
          "des": "花蓮縣",
          "no": "102100",
          "n": [
            {
              "des": "花蓮市",
              "no": "102101"
            },
            {
              "des": "新城鄉",
              "no": "102102"
            },
            {
              "des": "秀林鄉",
              "no": "102103"
            },
            {
              "des": "吉安鄉",
              "no": "102104"
            },
            {
              "des": "壽豐鄉",
              "no": "102105"
            },
            {
              "des": "鳳林鎮",
              "no": "102106"
            },
            {
              "des": "光復鄉",
              "no": "102107"
            },
            {
              "des": "豐濱鄉",
              "no": "102108"
            },
            {
              "des": "瑞穗鄉",
              "no": "102109"
            },
            {
              "des": "萬榮鄉",
              "no": "102110"
            },
            {
              "des": "玉里鎮",
              "no": "102111"
            },
            {
              "des": "卓溪鄉",
              "no": "102112"
            },
            {
              "des": "富里鄉",
              "no": "102113"
            }
          ]
        },
        {
          "des": "台東縣",
          "no": "102200",
          "n": [
            {
              "des": "台東市",
              "no": "102201"
            },
            {
              "des": "綠島鄉",
              "no": "102202"
            },
            {
              "des": "蘭嶼鄉",
              "no": "102203"
            },
            {
              "des": "延平鄉",
              "no": "102204"
            },
            {
              "des": "卑南鄉",
              "no": "102205"
            },
            {
              "des": "鹿野鄉",
              "no": "102206"
            },
            {
              "des": "關山鎮",
              "no": "102207"
            },
            {
              "des": "海端鄉",
              "no": "102208"
            },
            {
              "des": "池上鄉",
              "no": "102209"
            },
            {
              "des": "東河鄉",
              "no": "102210"
            },
            {
              "des": "成功鎮",
              "no": "102211"
            },
            {
              "des": "長濱鄉",
              "no": "102212"
            },
            {
              "des": "太麻里鄉",
              "no": "102213"
            },
            {
              "des": "金峰鄉",
              "no": "102214"
            },
            {
              "des": "大武鄉",
              "no": "102215"
            },
            {
              "des": "達仁鄉",
              "no": "102216"
            }
          ]
        }
      ]
    },
    {
      "des": "離島",
      "no": "5",
      "n": [
        {
          "des": "澎湖縣",
          "no": "102300",
          "n": [
            {
              "des": "馬公市",
              "no": "102301"
            },
            {
              "des": "西嶼鄉",
              "no": "102302"
            },
            {
              "des": "望安鄉",
              "no": "102303"
            },
            {
              "des": "七美鄉",
              "no": "102304"
            },
            {
              "des": "白沙鄉",
              "no": "102305"
            },
            {
              "des": "湖西鄉",
              "no": "102306"
            }
          ]
        },
        {
          "des": "金門縣",
          "no": "102400",
          "n": [
            {
              "des": "金沙鎮",
              "no": "102401"
            },
            {
              "des": "金湖鎮",
              "no": "102402"
            },
            {
              "des": "金寧鄉",
              "no": "102403"
            },
            {
              "des": "金城鎮",
              "no": "102404"
            },
            {
              "des": "烈嶼鄉",
              "no": "102405"
            },
            {
              "des": "烏坵鄉",
              "no": "102406"
            }
          ]
        },
        {
          "des": "連江縣",
          "no": "102500",
          "n": [
            {
              "des": "南竿鄉",
              "no": "102501"
            },
            {
              "des": "北竿鄉",
              "no": "102502"
            },
            {
              "des": "莒光鄉",
              "no": "102503"
            },
            {
              "des": "東引鄉",
              "no": "102504"
            }
          ]
        }
      ]
    },
    {
      "des": "中國",
      "no": "110000",
      "n": [
        {
          "des": "北京市",
          "no": "110100",
          "n": []
        },
        {
          "des": "天津市",
          "no": "110200",
          "n": []
        },
        {
          "des": "上海市",
          "no": "110300",
          "n": []
        },
        {
          "des": "重慶市",
          "no": "110400",
          "n": []
        },
        {
          "des": "廣東省",
          "no": "110500",
          "n": [
            {
              "des": "廣州市",
              "no": "110501"
            },
            {
              "des": "深圳市",
              "no": "110502"
            },
            {
              "des": "東莞市",
              "no": "110503"
            },
            {
              "des": "珠海市",
              "no": "110504"
            },
            {
              "des": "中山市",
              "no": "110505"
            },
            {
              "des": "惠州市",
              "no": "110506"
            },
            {
              "des": "汕頭市",
              "no": "110507"
            },
            {
              "des": "湛江市",
              "no": "110508"
            },
            {
              "des": "佛山市",
              "no": "110509"
            },
            {
              "des": "江門市",
              "no": "110510"
            },
            {
              "des": "河源市",
              "no": "110511"
            },
            {
              "des": "茂名市",
              "no": "110512"
            },
            {
              "des": "清遠市",
              "no": "110513"
            },
            {
              "des": "雲浮市",
              "no": "110514"
            },
            {
              "des": "肇慶市",
              "no": "110515"
            },
            {
              "des": "陽江市",
              "no": "110516"
            },
            {
              "des": "韶關市",
              "no": "110517"
            },
            {
              "des": "梅州市",
              "no": "110518"
            },
            {
              "des": "潮州市",
              "no": "110519"
            },
            {
              "des": "揭陽市",
              "no": "110520"
            },
            {
              "des": "汕尾市",
              "no": "110521"
            }
          ]
        },
        {
          "des": "福建省",
          "no": "110600",
          "n": [
            {
              "des": "廈門市",
              "no": "110601"
            },
            {
              "des": "福州市",
              "no": "110602"
            },
            {
              "des": "漳州市",
              "no": "110603"
            },
            {
              "des": "泉州市",
              "no": "110604"
            },
            {
              "des": "莆田市",
              "no": "110605"
            },
            {
              "des": "福清市",
              "no": "110606"
            },
            {
              "des": "龍巖市",
              "no": "110607"
            },
            {
              "des": "三明市",
              "no": "110608"
            },
            {
              "des": "南平市",
              "no": "110609"
            },
            {
              "des": "寧德市",
              "no": "110610"
            }
          ]
        },
        {
          "des": "海南省",
          "no": "110700",
          "n": [
            {
              "des": "三沙市",
              "no": "110701"
            },
            {
              "des": "海口市",
              "no": "110702"
            },
            {
              "des": "三亞市",
              "no": "110703"
            },
            {
              "des": "海南省省直轄",
              "no": "110704"
            },
            {
              "des": "萬寧市",
              "no": "110705"
            },
            {
              "des": "東方市",
              "no": "110706"
            },
            {
              "des": "臨高縣",
              "no": "110707"
            },
            {
              "des": "樂東黎族自治縣",
              "no": "110708"
            },
            {
              "des": "五指山市 ",
              "no": "110709"
            },
            {
              "des": "保亭黎族苗族自治縣",
              "no": "110710"
            },
            {
              "des": "儋州市",
              "no": "110711"
            },
            {
              "des": "定安縣",
              "no": "110712"
            },
            {
              "des": "屯昌縣 ",
              "no": "110713"
            },
            {
              "des": "文昌市",
              "no": "110714"
            },
            {
              "des": "昌江黎族自治縣",
              "no": "110715"
            },
            {
              "des": "澄邁縣",
              "no": "110716"
            },
            {
              "des": "瓊中黎族苗族自治縣 ",
              "no": "110717"
            },
            {
              "des": "瓊海市     ",
              "no": "110718"
            },
            {
              "des": "白沙黎族自治縣",
              "no": "110719"
            },
            {
              "des": "石柱土家族自治縣 ",
              "no": "110720"
            },
            {
              "des": "陵水黎族自治縣  ",
              "no": "110721"
            }
          ]
        },
        {
          "des": "浙江省",
          "no": "110800",
          "n": [
            {
              "des": "杭州市",
              "no": "110801"
            },
            {
              "des": "寧波市",
              "no": "110802"
            },
            {
              "des": "義烏市",
              "no": "110803"
            },
            {
              "des": "嘉興市",
              "no": "110804"
            },
            {
              "des": "金華市",
              "no": "110805"
            },
            {
              "des": "紹興市",
              "no": "110806"
            },
            {
              "des": "溫州市",
              "no": "110807"
            },
            {
              "des": "衢州市",
              "no": "110808"
            },
            {
              "des": "湖州市",
              "no": "110810"
            },
            {
              "des": "台州市",
              "no": "110811"
            },
            {
              "des": "麗水市",
              "no": "110812"
            },
            {
              "des": "舟山市",
              "no": "110813"
            }
          ]
        },
        {
          "des": "江蘇省",
          "no": "110900",
          "n": [
            {
              "des": "蘇州市",
              "no": "110901"
            },
            {
              "des": "崑山市",
              "no": "110902"
            },
            {
              "des": "南京市",
              "no": "110903"
            },
            {
              "des": "吳江區",
              "no": "110904"
            },
            {
              "des": "無錫市",
              "no": "110905"
            },
            {
              "des": "宿遷市",
              "no": "110906"
            },
            {
              "des": "南通市",
              "no": "110908"
            },
            {
              "des": "徐州市",
              "no": "110909"
            },
            {
              "des": "泰州市",
              "no": "110910"
            },
            {
              "des": "常州市",
              "no": "110911"
            },
            {
              "des": "常熟市",
              "no": "110912"
            },
            {
              "des": "揚州市",
              "no": "110913"
            },
            {
              "des": "鎮江市",
              "no": "110914"
            },
            {
              "des": "鹽城市",
              "no": "110915"
            },
            {
              "des": "張家港市",
              "no": "110916"
            },
            {
              "des": "江陰市",
              "no": "110917"
            },
            {
              "des": "太倉市",
              "no": "110918"
            },
            {
              "des": "淮安市",
              "no": "110919"
            },
            {
              "des": "連雲港市",
              "no": "110920"
            }
          ]
        },
        {
          "des": "山東省",
          "no": "111000",
          "n": [
            {
              "des": "臨沂市",
              "no": "111001"
            },
            {
              "des": "青島市",
              "no": "111002"
            },
            {
              "des": "煙台市",
              "no": "111003"
            },
            {
              "des": "威海市",
              "no": "111004"
            },
            {
              "des": "泰安市",
              "no": "111005"
            },
            {
              "des": "菏澤市",
              "no": "111007"
            },
            {
              "des": "濟南市",
              "no": "111008"
            },
            {
              "des": "淄博市",
              "no": "111009"
            },
            {
              "des": "濰坊市",
              "no": "111010"
            },
            {
              "des": "濟寧市",
              "no": "111011"
            },
            {
              "des": "東營市",
              "no": "111012"
            },
            {
              "des": "日照市",
              "no": "111013"
            },
            {
              "des": "德州市",
              "no": "111014"
            },
            {
              "des": "棗莊市",
              "no": "111015"
            },
            {
              "des": "萊蕪市",
              "no": "111016"
            },
            {
              "des": "聊城市",
              "no": "111017"
            },
            {
              "des": "濱州市",
              "no": "111018"
            }
          ]
        },
        {
          "des": "河北省",
          "no": "111100",
          "n": [
            {
              "des": "石家莊市",
              "no": "111101"
            },
            {
              "des": "保定市",
              "no": "111102"
            },
            {
              "des": "唐山市",
              "no": "111103"
            },
            {
              "des": "廊坊市",
              "no": "111104"
            },
            {
              "des": "秦皇島市",
              "no": "111105"
            },
            {
              "des": "邯鄲市",
              "no": "111106"
            },
            {
              "des": "邢台市",
              "no": "111107"
            },
            {
              "des": "張家口市",
              "no": "111108"
            },
            {
              "des": "承德市",
              "no": "111109"
            },
            {
              "des": "滄州市",
              "no": "111110"
            },
            {
              "des": "衡水市",
              "no": "111111"
            }
          ]
        },
        {
          "des": "遼寧省",
          "no": "111200",
          "n": [
            {
              "des": "大連市",
              "no": "111201"
            },
            {
              "des": "鞍山市",
              "no": "111202"
            },
            {
              "des": "瀋陽市",
              "no": "111203"
            },
            {
              "des": "營口市",
              "no": "111204"
            },
            {
              "des": "撫順市",
              "no": "111205"
            },
            {
              "des": "錦州市",
              "no": "111206"
            },
            {
              "des": "丹東市",
              "no": "111207"
            },
            {
              "des": "葫蘆島市",
              "no": "111208"
            },
            {
              "des": "本溪市",
              "no": "111209"
            },
            {
              "des": "遼陽市",
              "no": "111210"
            },
            {
              "des": "鐵嶺市",
              "no": "111211"
            },
            {
              "des": "阜新市",
              "no": "111212"
            },
            {
              "des": "盤錦市",
              "no": "111213"
            },
            {
              "des": "朝陽市",
              "no": "111214"
            }
          ]
        },
        {
          "des": "吉林省",
          "no": "111300",
          "n": [
            {
              "des": "吉林市",
              "no": "111301"
            },
            {
              "des": "長春市",
              "no": "111302"
            },
            {
              "des": "遼源市",
              "no": "111303"
            },
            {
              "des": "通化市",
              "no": "111304"
            },
            {
              "des": "四平市",
              "no": "111305"
            },
            {
              "des": "白山市",
              "no": "111306"
            },
            {
              "des": "松原市",
              "no": "111307"
            },
            {
              "des": "白城市",
              "no": "111308"
            },
            {
              "des": "延邊朝鮮族自治州",
              "no": "111309"
            }
          ]
        },
        {
          "des": "黑龍江省",
          "no": "111400",
          "n": [
            {
              "des": "哈爾濱市",
              "no": "111401"
            },
            {
              "des": "伊春市",
              "no": "111402"
            },
            {
              "des": "綏化市",
              "no": "111403"
            },
            {
              "des": "大慶市",
              "no": "111404"
            },
            {
              "des": "齊齊哈爾市",
              "no": "111405"
            },
            {
              "des": "牡丹江市",
              "no": "111406"
            },
            {
              "des": "佳木斯市",
              "no": "111407"
            },
            {
              "des": "雞西市",
              "no": "111408"
            },
            {
              "des": "鶴崗市",
              "no": "111409"
            },
            {
              "des": "雙鴨山市",
              "no": "111410"
            },
            {
              "des": "七台河市",
              "no": "111411"
            },
            {
              "des": "黑河市",
              "no": "111412"
            },
            {
              "des": "大興安嶺地區",
              "no": "111413"
            }
          ]
        },
        {
          "des": "湖南省",
          "no": "111500",
          "n": [
            {
              "des": "長沙市",
              "no": "111501"
            },
            {
              "des": "張家界市",
              "no": "111502"
            },
            {
              "des": "株州市",
              "no": "111503"
            },
            {
              "des": "湘潭市",
              "no": "111504"
            },
            {
              "des": "衡陽市",
              "no": "111505"
            },
            {
              "des": "岳陽市",
              "no": "111506"
            },
            {
              "des": "常德市",
              "no": "111507"
            },
            {
              "des": "益陽市",
              "no": "111508"
            },
            {
              "des": "郴州市",
              "no": "111509"
            },
            {
              "des": "邵陽市",
              "no": "111510"
            },
            {
              "des": "懷化市",
              "no": "111511"
            },
            {
              "des": "婁底市",
              "no": "111512"
            },
            {
              "des": "永州市",
              "no": "111513"
            },
            {
              "des": "湘西土家族苗族自治州",
              "no": "111514"
            }
          ]
        },
        {
          "des": "湖北省",
          "no": "111600",
          "n": [
            {
              "des": "宜昌市",
              "no": "111601"
            },
            {
              "des": "武漢市",
              "no": "111602"
            },
            {
              "des": "襄陽市",
              "no": "111603"
            },
            {
              "des": "黃石市",
              "no": "111604"
            },
            {
              "des": "荊門市",
              "no": "111605"
            },
            {
              "des": "十堰市",
              "no": "111606"
            },
            {
              "des": "荊州市",
              "no": "111607"
            },
            {
              "des": "孝感市",
              "no": "111608"
            },
            {
              "des": "鄂州市",
              "no": "111609"
            },
            {
              "des": "天門市",
              "no": "111610"
            },
            {
              "des": "黃岡市",
              "no": "111611"
            },
            {
              "des": "咸寧市",
              "no": "111612"
            },
            {
              "des": "隨州市",
              "no": "111613"
            },
            {
              "des": "潛江市",
              "no": "111614"
            },
            {
              "des": "仙桃市",
              "no": "111615"
            },
            {
              "des": "神農架林區",
              "no": "111616"
            },
            {
              "des": "恩施土家族苗族自治州",
              "no": "111617"
            },
            {
              "des": "襄樊市 ",
              "no": "111618"
            }
          ]
        },
        {
          "des": "江西省",
          "no": "111700",
          "n": [
            {
              "des": "南昌市",
              "no": "111701"
            },
            {
              "des": "九江市",
              "no": "111702"
            },
            {
              "des": "贛州市",
              "no": "111703"
            },
            {
              "des": "景德鎮市",
              "no": "111704"
            },
            {
              "des": "萍鄉市",
              "no": "111705"
            },
            {
              "des": "新余市",
              "no": "111706"
            },
            {
              "des": "鷹潭市",
              "no": "111707"
            },
            {
              "des": "吉安市",
              "no": "111708"
            },
            {
              "des": "宜春市",
              "no": "111709"
            },
            {
              "des": "撫州市",
              "no": "111710"
            },
            {
              "des": "上饒市",
              "no": "111711"
            }
          ]
        },
        {
          "des": "安徽省",
          "no": "111800",
          "n": [
            {
              "des": "合肥市",
              "no": "111801"
            },
            {
              "des": "蕪湖市",
              "no": "111802"
            },
            {
              "des": "安慶市",
              "no": "111803"
            },
            {
              "des": "馬鞍山市",
              "no": "111804"
            },
            {
              "des": "蚌埠市",
              "no": "111805"
            },
            {
              "des": "阜陽市",
              "no": "111806"
            },
            {
              "des": "銅陵市",
              "no": "111807"
            },
            {
              "des": "滁州市",
              "no": "111808"
            },
            {
              "des": "黃山市",
              "no": "111809"
            },
            {
              "des": "淮南市",
              "no": "111810"
            },
            {
              "des": "六安市",
              "no": "111811"
            },
            {
              "des": "巢湖市",
              "no": "111812"
            },
            {
              "des": "宣城市",
              "no": "111813"
            },
            {
              "des": "池州市",
              "no": "111814"
            },
            {
              "des": "淮北市",
              "no": "111815"
            },
            {
              "des": "宿州市",
              "no": "111816"
            },
            {
              "des": "亳州市",
              "no": "111817"
            }
          ]
        },
        {
          "des": "河南省",
          "no": "111900",
          "n": [
            {
              "des": "鄭州市",
              "no": "111901"
            },
            {
              "des": "洛陽市",
              "no": "111902"
            },
            {
              "des": "開封市",
              "no": "111903"
            },
            {
              "des": "平頂山市",
              "no": "111904"
            },
            {
              "des": "安陽市",
              "no": "111905"
            },
            {
              "des": "鶴壁市",
              "no": "111906"
            },
            {
              "des": "新鄉市",
              "no": "111907"
            },
            {
              "des": "焦作市",
              "no": "111908"
            },
            {
              "des": "濮陽市",
              "no": "111909"
            },
            {
              "des": "許昌市",
              "no": "111910"
            },
            {
              "des": "漯河市",
              "no": "111911"
            },
            {
              "des": "三門峽市",
              "no": "111912"
            },
            {
              "des": "南陽市",
              "no": "111913"
            },
            {
              "des": "商丘市",
              "no": "111914"
            },
            {
              "des": "信陽市",
              "no": "111915"
            },
            {
              "des": "周口市",
              "no": "111916"
            },
            {
              "des": "駐馬店市",
              "no": "111917"
            },
            {
              "des": "濟源市",
              "no": "111918"
            },
            {
              "des": "河南省省直轄",
              "no": "111919"
            }
          ]
        },
        {
          "des": "山西省",
          "no": "112000",
          "n": [
            {
              "des": "太原市",
              "no": "112001"
            },
            {
              "des": "運城市",
              "no": "112002"
            },
            {
              "des": "大同市",
              "no": "112003"
            },
            {
              "des": "臨汾市",
              "no": "112004"
            },
            {
              "des": "陽泉市",
              "no": "112005"
            },
            {
              "des": "長治市",
              "no": "112006"
            },
            {
              "des": "晉城市",
              "no": "112007"
            },
            {
              "des": "朔州市",
              "no": "112008"
            },
            {
              "des": "晉中市",
              "no": "112009"
            },
            {
              "des": "忻州市",
              "no": "112010"
            },
            {
              "des": "呂梁市",
              "no": "112011"
            }
          ]
        },
        {
          "des": "陜西省",
          "no": "112100",
          "n": [
            {
              "des": "西安市",
              "no": "112101"
            },
            {
              "des": "咸陽市",
              "no": "112102"
            },
            {
              "des": "寶雞市",
              "no": "112103"
            },
            {
              "des": "銅川市",
              "no": "112104"
            },
            {
              "des": "延安市",
              "no": "112105"
            },
            {
              "des": "渭南市",
              "no": "112106"
            },
            {
              "des": "漢中市",
              "no": "112107"
            },
            {
              "des": "榆林市",
              "no": "112108"
            },
            {
              "des": "安康市",
              "no": "112109"
            },
            {
              "des": "商洛市",
              "no": "112110"
            }
          ]
        },
        {
          "des": "甘肅省",
          "no": "112200",
          "n": [
            {
              "des": "蘭州市",
              "no": "112201"
            },
            {
              "des": "金昌市",
              "no": "112202"
            },
            {
              "des": "嘉峪關市",
              "no": "112204"
            },
            {
              "des": "白銀市",
              "no": "112205"
            },
            {
              "des": "天水市",
              "no": "112206"
            },
            {
              "des": "武威市",
              "no": "112207"
            },
            {
              "des": "張掖市",
              "no": "112208"
            },
            {
              "des": "平涼市",
              "no": "112209"
            },
            {
              "des": "酒泉市",
              "no": "112210"
            },
            {
              "des": "慶陽市",
              "no": "112211"
            },
            {
              "des": "定西市",
              "no": "112212"
            },
            {
              "des": "隴南市",
              "no": "112213"
            },
            {
              "des": "臨夏回族自治州",
              "no": "112214"
            },
            {
              "des": "甘南藏族自治州",
              "no": "112215"
            }
          ]
        },
        {
          "des": "四川省",
          "no": "112300",
          "n": [
            {
              "des": "成都市",
              "no": "112301"
            },
            {
              "des": "綿陽市",
              "no": "112302"
            },
            {
              "des": "樂山市",
              "no": "112303"
            },
            {
              "des": "瀘洲市",
              "no": "112304"
            },
            {
              "des": "德陽市",
              "no": "112305"
            },
            {
              "des": "宜賓市",
              "no": "112306"
            },
            {
              "des": "自貢市",
              "no": "112307"
            },
            {
              "des": "內江市",
              "no": "112308"
            },
            {
              "des": "雅安市",
              "no": "112310"
            },
            {
              "des": "攀枝花市",
              "no": "112311"
            },
            {
              "des": "瀘州市",
              "no": "112312"
            },
            {
              "des": "廣元市",
              "no": "112313"
            },
            {
              "des": "遂寧市",
              "no": "112314"
            },
            {
              "des": "南充市",
              "no": "112315"
            },
            {
              "des": "眉山市",
              "no": "112316"
            },
            {
              "des": "廣安市",
              "no": "112317"
            },
            {
              "des": "達州市",
              "no": "112318"
            },
            {
              "des": "巴中市",
              "no": "112319"
            },
            {
              "des": "資陽市",
              "no": "112320"
            },
            {
              "des": "阿壩藏族羌族自治州",
              "no": "112321"
            },
            {
              "des": "甘孜藏族自治州",
              "no": "112322"
            },
            {
              "des": "涼山彝族自治州",
              "no": "112323"
            }
          ]
        },
        {
          "des": "貴州省",
          "no": "112400",
          "n": [
            {
              "des": "貴陽市",
              "no": "112401"
            },
            {
              "des": "遵義市",
              "no": "112402"
            },
            {
              "des": "六盤水市",
              "no": "112403"
            },
            {
              "des": "安順市",
              "no": "112404"
            },
            {
              "des": "畢節市",
              "no": "112405"
            },
            {
              "des": "銅仁市",
              "no": "112406"
            },
            {
              "des": "黔西南布依族苗族自治州",
              "no": "112407"
            },
            {
              "des": "黔東南苗族侗族自治州",
              "no": "112408"
            },
            {
              "des": "黔南布依族苗族自治州",
              "no": "112409"
            }
          ]
        },
        {
          "des": "雲南省",
          "no": "112500",
          "n": [
            {
              "des": "昆明市",
              "no": "112501"
            },
            {
              "des": "曲靖市",
              "no": "112502"
            },
            {
              "des": "玉溪市",
              "no": "112503"
            },
            {
              "des": "大理市",
              "no": "112504"
            },
            {
              "des": "麗江市",
              "no": "112505"
            },
            {
              "des": "蒙自市",
              "no": "112506"
            },
            {
              "des": "開遠市",
              "no": "112507"
            },
            {
              "des": "箇舊市",
              "no": "112508"
            },
            {
              "des": "紅河州",
              "no": "112509"
            },
            {
              "des": "保山市",
              "no": "112510"
            },
            {
              "des": "迪慶藏族自治州",
              "no": "112511"
            },
            {
              "des": "怒江傈僳族自治州",
              "no": "112512"
            },
            {
              "des": "德宏傣族景頗族自治州",
              "no": "112513"
            },
            {
              "des": "西雙版納傣族自治州",
              "no": "112514"
            },
            {
              "des": "文山壯族苗族自治州",
              "no": "112515"
            },
            {
              "des": "楚雄彝族自治州",
              "no": "112516"
            }
          ]
        },
        {
          "des": "內蒙古",
          "no": "112600",
          "n": [
            {
              "des": "呼和浩特市",
              "no": "112601"
            },
            {
              "des": "包頭市",
              "no": "112602"
            },
            {
              "des": "烏海市",
              "no": "112603"
            },
            {
              "des": "赤峰市",
              "no": "112604"
            },
            {
              "des": "通遼市",
              "no": "112605"
            },
            {
              "des": "鄂爾多斯市",
              "no": "112606"
            },
            {
              "des": "呼倫貝爾市",
              "no": "112607"
            },
            {
              "des": "巴彥淖爾市",
              "no": "112608"
            },
            {
              "des": "烏蘭察布市",
              "no": "112609"
            }
          ]
        },
        {
          "des": "西藏",
          "no": "112700",
          "n": [
            {
              "des": "拉薩市",
              "no": "112701"
            },
            {
              "des": "日喀則市",
              "no": "112702"
            },
            {
              "des": "昌都市",
              "no": "112703"
            },
            {
              "des": "林芝市",
              "no": "112704"
            },
            {
              "des": "山南市",
              "no": "112705"
            },
            {
              "des": "那曲市",
              "no": "112706"
            },
            {
              "des": "阿里地區",
              "no": "112707"
            }
          ]
        },
        {
          "des": "寧夏",
          "no": "112800",
          "n": [
            {
              "des": "銀川市",
              "no": "112801"
            },
            {
              "des": "賀蘭縣",
              "no": "112802"
            },
            {
              "des": "寧朔縣",
              "no": "112803"
            },
            {
              "des": "靈武縣",
              "no": "112804"
            },
            {
              "des": "鹽池縣",
              "no": "112805"
            },
            {
              "des": "平羅縣",
              "no": "112806"
            },
            {
              "des": "磴口縣",
              "no": "112807"
            },
            {
              "des": "中衛縣",
              "no": "112808"
            },
            {
              "des": "中寧縣",
              "no": "112809"
            },
            {
              "des": "金積縣",
              "no": "112810"
            },
            {
              "des": "同心縣",
              "no": "112811"
            },
            {
              "des": "陶樂縣",
              "no": "112812"
            },
            {
              "des": "永寧縣",
              "no": "112813"
            },
            {
              "des": "惠農縣",
              "no": "112814"
            },
            {
              "des": "紫湖設治局",
              "no": "112815"
            },
            {
              "des": "居延設治局",
              "no": "112816"
            },
            {
              "des": "香山設治局",
              "no": "112817"
            }
          ]
        },
        {
          "des": "新疆",
          "no": "112900",
          "n": [
            {
              "des": "烏魯木齊市",
              "no": "112901"
            },
            {
              "des": "克拉瑪依市",
              "no": "112902"
            },
            {
              "des": "喀什地區",
              "no": "112903"
            },
            {
              "des": "哈密市",
              "no": "112904"
            },
            {
              "des": "昌吉回族自治州",
              "no": "112905"
            },
            {
              "des": "博爾塔拉蒙古自治州",
              "no": "112906"
            },
            {
              "des": "巴音郭楞蒙古自治州",
              "no": "112907"
            },
            {
              "des": "克孜勒蘇柯爾克孜自治州",
              "no": "112908"
            },
            {
              "des": "伊犁哈薩克自治州",
              "no": "112909"
            },
            {
              "des": "阿克蘇地區",
              "no": "112910"
            },
            {
              "des": "喀什地區",
              "no": "112911"
            },
            {
              "des": "和田地區",
              "no": "112912"
            },
            {
              "des": "塔城地區",
              "no": "112913"
            },
            {
              "des": "阿勒泰地區",
              "no": "112914"
            },
            {
              "des": "石河子市",
              "no": "112915"
            },
            {
              "des": "阿拉爾市",
              "no": "112916"
            },
            {
              "des": "圖木舒克市",
              "no": "112917"
            },
            {
              "des": "五家渠市",
              "no": "112918"
            },
            {
              "des": "北屯市",
              "no": "112919"
            },
            {
              "des": "鐵門關市",
              "no": "112920"
            },
            {
              "des": "雙河市",
              "no": "112921"
            },
            {
              "des": "可克達拉市",
              "no": "112922"
            },
            {
              "des": "崑玉市",
              "no": "112923"
            },
            {
              "des": "胡楊河市",
              "no": "112924"
            },
            {
              "des": "新星市",
              "no": "112925"
            },
            {
              "des": "吐魯番市",
              "no": "112926"
            }
          ]
        },
        {
          "des": "廣西",
          "no": "113000",
          "n": [
            {
              "des": "南寧市",
              "no": "113001"
            },
            {
              "des": "柳州市",
              "no": "113002"
            },
            {
              "des": "桂林市",
              "no": "113003"
            },
            {
              "des": "梧州市",
              "no": "113004"
            },
            {
              "des": "北海市",
              "no": "113005"
            },
            {
              "des": "欽州市",
              "no": "113006"
            },
            {
              "des": "貴港市",
              "no": "113007"
            },
            {
              "des": "玉林市",
              "no": "113008"
            },
            {
              "des": "百色市",
              "no": "113009"
            },
            {
              "des": "賀州市",
              "no": "113010"
            },
            {
              "des": "河池市",
              "no": "113011"
            },
            {
              "des": "來賓市",
              "no": "113012"
            },
            {
              "des": "崇左市",
              "no": "113013"
            },
            {
              "des": "防城港市",
              "no": "113014"
            }
          ]
        },
        {
          "des": "青海省",
          "no": "113100",
          "n": [
            {
              "des": "西寧市",
              "no": "113101"
            },
            {
              "des": "海東市",
              "no": "113102"
            },
            {
              "des": "海北藏族自治州",
              "no": "113103"
            },
            {
              "des": "黃南藏族自治州",
              "no": "113104"
            },
            {
              "des": "海南藏族自治州",
              "no": "113105"
            },
            {
              "des": "果洛藏族自治州",
              "no": "113106"
            },
            {
              "des": "玉樹藏族自治州",
              "no": "113107"
            },
            {
              "des": "海西蒙古族藏族自治州",
              "no": "113108"
            }
          ]
        }
      ]
    },
    {
      "des": "亞洲",
      "no": "120000",
      "n": [
        {
          "des": "東北亞",
          "no": "120100",
          "n": [
            {
              "des": "日本",
              "no": "120101"
            },
            {
              "des": "韓國",
              "no": "120102"
            },
            {
              "des": "香港",
              "no": "120103"
            },
            {
              "des": "澳門",
              "no": "120104"
            }
          ]
        },
        {
          "des": "東南亞",
          "no": "120200",
          "n": [
            {
              "des": "泰國",
              "no": "120201"
            },
            {
              "des": "越南",
              "no": "120202"
            },
            {
              "des": "印尼",
              "no": "120203"
            },
            {
              "des": "緬甸",
              "no": "120204"
            },
            {
              "des": "寮國",
              "no": "120205"
            },
            {
              "des": "汶萊",
              "no": "120206"
            },
            {
              "des": "新加坡",
              "no": "120207"
            },
            {
              "des": "菲律賓",
              "no": "120208"
            },
            {
              "des": "柬埔寨",
              "no": "120209"
            },
            {
              "des": "馬來西亞",
              "no": "120210"
            }
          ]
        },
        {
          "des": "亞洲其它",
          "no": "120300",
          "n": [
            {
              "des": "印度",
              "no": "120301"
            },
            {
              "des": "約旦",
              "no": "120302"
            },
            {
              "des": "伊朗",
              "no": "120303"
            },
            {
              "des": "蒙古",
              "no": "120304"
            },
            {
              "des": "不丹",
              "no": "120305"
            },
            {
              "des": "巴林",
              "no": "120306"
            },
            {
              "des": "阿曼",
              "no": "120307"
            },
            {
              "des": "卡達",
              "no": "120308"
            },
            {
              "des": "葉門",
              "no": "120309"
            },
            {
              "des": "阿富汗",
              "no": "120310"
            },
            {
              "des": "伊拉克",
              "no": "120311"
            },
            {
              "des": "以色列",
              "no": "120312"
            },
            {
              "des": "科威特",
              "no": "120313"
            },
            {
              "des": "孟加拉",
              "no": "120314"
            },
            {
              "des": "敘利亞",
              "no": "120315"
            },
            {
              "des": "土耳其",
              "no": "120316"
            },
            {
              "des": "尼泊爾",
              "no": "120317"
            },
            {
              "des": "哈薩克",
              "no": "120318"
            },
            {
              "des": "喬治亞",
              "no": "120319"
            },
            {
              "des": "東帝汶",
              "no": "120320"
            },
            {
              "des": "塔吉克",
              "no": "120321"
            },
            {
              "des": "土庫曼",
              "no": "120322"
            },
            {
              "des": "黎巴嫩",
              "no": "120323"
            },
            {
              "des": "馬爾地夫",
              "no": "120324"
            },
            {
              "des": "巴基斯坦",
              "no": "120325"
            },
            {
              "des": "斯里蘭卡",
              "no": "120326"
            },
            {
              "des": "亞美尼亞",
              "no": "120327"
            },
            {
              "des": "亞塞拜然",
              "no": "120328"
            },
            {
              "des": "吉爾吉斯",
              "no": "120329"
            },
            {
              "des": "烏茲別克",
              "no": "120330"
            },
            {
              "des": "阿拉伯聯合大公國",
              "no": "120331"
            },
            {
              "des": "沙烏地阿拉伯",
              "no": "120332"
            }
          ]
        }
      ]
    },
    {
      "des": "美洲",
      "no": "130000",
      "n": [
        {
          "des": "美國",
          "no": "130100",
          "n": [
            {
              "des": "華盛頓州",
              "no": "130101"
            },
            {
              "des": "俄勒岡州",
              "no": "130102"
            },
            {
              "des": "加利福尼亞州",
              "no": "130103"
            },
            {
              "des": "愛達荷州",
              "no": "130104"
            },
            {
              "des": "內華達州",
              "no": "130105"
            },
            {
              "des": "猶他州",
              "no": "130106"
            },
            {
              "des": "亞利桑那州",
              "no": "130107"
            },
            {
              "des": "蒙大拿州",
              "no": "130108"
            },
            {
              "des": "懷俄明州",
              "no": "130109"
            },
            {
              "des": "科羅拉多州",
              "no": "130110"
            },
            {
              "des": "新墨西哥州",
              "no": "130111"
            },
            {
              "des": "北達科他州",
              "no": "130112"
            },
            {
              "des": "南達科他州",
              "no": "130113"
            },
            {
              "des": "內布拉斯加州",
              "no": "130114"
            },
            {
              "des": "堪薩斯州",
              "no": "130115"
            },
            {
              "des": "奧克拉荷馬州",
              "no": "130116"
            },
            {
              "des": "德克薩斯州",
              "no": "130117"
            },
            {
              "des": "明尼蘇達州",
              "no": "130118"
            },
            {
              "des": "愛荷華州",
              "no": "130119"
            },
            {
              "des": "密蘇里州",
              "no": "130120"
            },
            {
              "des": "阿肯色州",
              "no": "130121"
            },
            {
              "des": "路易斯安那州",
              "no": "130122"
            },
            {
              "des": "威斯康辛州",
              "no": "130123"
            },
            {
              "des": "伊利諾州",
              "no": "130124"
            },
            {
              "des": "密西根州",
              "no": "130125"
            },
            {
              "des": "印第安納州",
              "no": "130126"
            },
            {
              "des": "肯塔基州",
              "no": "130127"
            },
            {
              "des": "田納西州",
              "no": "130128"
            },
            {
              "des": "密西西比州",
              "no": "130129"
            },
            {
              "des": "阿拉巴馬州",
              "no": "130130"
            },
            {
              "des": "緬因州",
              "no": "130131"
            },
            {
              "des": "新罕布夏州",
              "no": "130132"
            },
            {
              "des": "佛蒙特州",
              "no": "130133"
            },
            {
              "des": "馬薩諸塞州",
              "no": "130134"
            },
            {
              "des": "紐約州",
              "no": "130135"
            },
            {
              "des": "賓夕法尼亞州",
              "no": "130136"
            },
            {
              "des": "維吉尼亞州",
              "no": "130137"
            },
            {
              "des": "北卡羅來納州",
              "no": "130138"
            },
            {
              "des": "南卡羅來納州",
              "no": "130139"
            },
            {
              "des": "喬治亞州",
              "no": "130140"
            },
            {
              "des": "佛羅里達州",
              "no": "130141"
            },
            {
              "des": "羅德島州",
              "no": "130142"
            },
            {
              "des": "康乃狄克州",
              "no": "130143"
            },
            {
              "des": "紐澤西州",
              "no": "130144"
            },
            {
              "des": "德拉瓦州",
              "no": "130145"
            },
            {
              "des": "馬里蘭州",
              "no": "130146"
            },
            {
              "des": "西維吉尼亞州",
              "no": "130147"
            },
            {
              "des": "阿拉斯加州",
              "no": "130148"
            },
            {
              "des": "夏威夷州",
              "no": "130149"
            },
            {
              "des": "俄亥俄州",
              "no": "130150"
            },
            {
              "des": "華盛頓哥倫比亞特區",
              "no": "130151"
            }
          ]
        },
        {
          "des": "加拿大",
          "no": "130200",
          "n": [
            {
              "des": "多倫多",
              "no": "130201"
            },
            {
              "des": "蒙特婁",
              "no": "130202"
            },
            {
              "des": "溫哥華",
              "no": "130203"
            },
            {
              "des": "渥太華",
              "no": "130204"
            },
            {
              "des": "卡加利",
              "no": "130205"
            },
            {
              "des": "艾德蒙頓",
              "no": "130206"
            }
          ]
        },
        {
          "des": "中南美洲",
          "no": "130300",
          "n": [
            {
              "des": "墨西哥",
              "no": "130301"
            },
            {
              "des": "巴拿馬",
              "no": "130302"
            },
            {
              "des": "貝里斯",
              "no": "130303"
            },
            {
              "des": "聖文森",
              "no": "130304"
            },
            {
              "des": "宏都拉斯",
              "no": "130305"
            },
            {
              "des": "尼加拉瓜",
              "no": "130306"
            },
            {
              "des": "薩爾瓦多",
              "no": "130307"
            },
            {
              "des": "瓜地馬拉",
              "no": "130308"
            },
            {
              "des": "哥斯大黎加",
              "no": "130309"
            },
            {
              "des": "智利",
              "no": "130310"
            },
            {
              "des": "巴西",
              "no": "130311"
            },
            {
              "des": "秘魯",
              "no": "130312"
            },
            {
              "des": "阿根廷",
              "no": "130313"
            },
            {
              "des": "巴拉圭",
              "no": "130314"
            },
            {
              "des": "烏拉圭",
              "no": "130315"
            },
            {
              "des": "厄瓜多",
              "no": "130316"
            },
            {
              "des": "蘇利南",
              "no": "130317"
            },
            {
              "des": "哥倫比亞",
              "no": "130318"
            },
            {
              "des": "多明尼加",
              "no": "130319"
            },
            {
              "des": "玻利維亞",
              "no": "130320"
            },
            {
              "des": "百慕達",
              "no": "130321"
            },
            {
              "des": "海地",
              "no": "130322"
            },
            {
              "des": "聖露西亞",
              "no": "130323"
            }
          ]
        }
      ]
    },
    {
      "des": "歐洲",
      "no": "140000",
      "n": [
        {
          "des": "北歐",
          "no": "140100",
          "n": [
            {
              "des": "挪威",
              "no": "140101"
            },
            {
              "des": "瑞典",
              "no": "140102"
            },
            {
              "des": "芬蘭",
              "no": "140103"
            },
            {
              "des": "丹麥",
              "no": "140104"
            },
            {
              "des": "冰島",
              "no": "140105"
            }
          ]
        },
        {
          "des": "南歐",
          "no": "140200",
          "n": [
            {
              "des": "希臘",
              "no": "140201"
            },
            {
              "des": "義大利",
              "no": "140202"
            },
            {
              "des": "西班牙",
              "no": "140203"
            },
            {
              "des": "馬其頓",
              "no": "140204"
            },
            {
              "des": "馬爾他",
              "no": "140205"
            },
            {
              "des": "葡萄牙",
              "no": "140206"
            },
            {
              "des": "保加利亞",
              "no": "140207"
            },
            {
              "des": "賽普勒斯",
              "no": "140208"
            },
            {
              "des": "羅馬尼亞",
              "no": "140209"
            },
            {
              "des": "聖馬利諾",
              "no": "140210"
            },
            {
              "des": "克羅埃西亞",
              "no": "140211"
            },
            {
              "des": "斯洛維尼亞",
              "no": "140212"
            },
            {
              "des": "波士尼亞赫塞哥維納",
              "no": "140213"
            },
            {
              "des": "阿爾巴尼亞",
              "no": "140214"
            },
            {
              "des": "安道爾",
              "no": "140215"
            }
          ]
        },
        {
          "des": "東歐",
          "no": "140300",
          "n": [
            {
              "des": "俄羅斯",
              "no": "140301"
            },
            {
              "des": "烏克蘭",
              "no": "140302"
            },
            {
              "des": "立陶宛",
              "no": "140303"
            },
            {
              "des": "白俄羅斯",
              "no": "140304"
            },
            {
              "des": "愛沙尼亞",
              "no": "140305"
            },
            {
              "des": "拉脫維亞",
              "no": "140306"
            },
            {
              "des": "摩爾多瓦",
              "no": "140307"
            },
            {
              "des": "塞爾維亞",
              "no": "140308"
            }
          ]
        },
        {
          "des": "西歐",
          "no": "140400",
          "n": [
            {
              "des": "法國",
              "no": "140401"
            },
            {
              "des": "英國",
              "no": "140402"
            },
            {
              "des": "荷蘭",
              "no": "140403"
            },
            {
              "des": "比利時",
              "no": "140404"
            },
            {
              "des": "愛爾蘭",
              "no": "140405"
            },
            {
              "des": "盧森堡",
              "no": "140406"
            },
            {
              "des": "摩納哥",
              "no": "140407"
            }
          ]
        },
        {
          "des": "中歐",
          "no": "140500",
          "n": [
            {
              "des": "德國",
              "no": "140501"
            },
            {
              "des": "捷克",
              "no": "140502"
            },
            {
              "des": "波蘭",
              "no": "140503"
            },
            {
              "des": "瑞士",
              "no": "140504"
            },
            {
              "des": "奧地利",
              "no": "140505"
            },
            {
              "des": "匈牙利",
              "no": "140506"
            },
            {
              "des": "斯洛伐克",
              "no": "140507"
            },
            {
              "des": "列支敦斯登",
              "no": "140508"
            }
          ]
        }
      ]
    },
    {
      "des": "非洲",
      "no": "150000",
      "n": [
        {
          "des": "北非",
          "no": "150100",
          "n": [
            {
              "des": "埃及",
              "no": "150101"
            },
            {
              "des": "蘇丹",
              "no": "150102"
            },
            {
              "des": "利比亞",
              "no": "150103"
            },
            {
              "des": "摩洛哥",
              "no": "150104"
            },
            {
              "des": "西撒哈拉",
              "no": "150105"
            },
            {
              "des": "突尼西亞",
              "no": "150106"
            },
            {
              "des": "阿爾及利亞",
              "no": "150107"
            }
          ]
        },
        {
          "des": "中非",
          "no": "150200",
          "n": [
            {
              "des": "中非",
              "no": "150201"
            },
            {
              "des": "剛果",
              "no": "150202"
            },
            {
              "des": "加彭",
              "no": "150203"
            },
            {
              "des": "喀麥隆",
              "no": "150204"
            },
            {
              "des": "聖多美和普林西比",
              "no": "150205"
            }
          ]
        },
        {
          "des": "南非",
          "no": "150300",
          "n": [
            {
              "des": "南非",
              "no": "150301"
            },
            {
              "des": "安哥拉",
              "no": "150302"
            },
            {
              "des": "波札那",
              "no": "150303"
            },
            {
              "des": "賴索托",
              "no": "150304"
            },
            {
              "des": "馬拉威",
              "no": "150305"
            },
            {
              "des": "尚比亞",
              "no": "150306"
            },
            {
              "des": "留尼旺",
              "no": "150307"
            },
            {
              "des": "模里西斯",
              "no": "150308"
            },
            {
              "des": "莫三比克",
              "no": "150309"
            },
            {
              "des": "納米比亞",
              "no": "150310"
            },
            {
              "des": "史瓦濟蘭",
              "no": "150311"
            },
            {
              "des": "聖赫倫那",
              "no": "150312"
            },
            {
              "des": "馬達加斯加",
              "no": "150313"
            }
          ]
        },
        {
          "des": "東非",
          "no": "150400",
          "n": [
            {
              "des": "肯亞",
              "no": "150401"
            },
            {
              "des": "葛摩",
              "no": "150402"
            },
            {
              "des": "蒲隆地",
              "no": "150403"
            },
            {
              "des": "吉布地",
              "no": "150404"
            },
            {
              "des": "盧安達",
              "no": "150405"
            },
            {
              "des": "塞席爾",
              "no": "150406"
            },
            {
              "des": "衣索比亞",
              "no": "150407"
            },
            {
              "des": "索馬利亞",
              "no": "150408"
            },
            {
              "des": "厄利垂亞",
              "no": "150409"
            },
            {
              "des": "坦尚尼亞",
              "no": "150410"
            },
            {
              "des": "烏干達",
              "no": "150411"
            }
          ]
        },
        {
          "des": "西非",
          "no": "150500",
          "n": [
            {
              "des": "馬利",
              "no": "150501"
            },
            {
              "des": "尼日",
              "no": "150502"
            },
            {
              "des": "多哥",
              "no": "150503"
            },
            {
              "des": "查德",
              "no": "150504"
            },
            {
              "des": "貝南",
              "no": "150505"
            },
            {
              "des": "迦納",
              "no": "150506"
            },
            {
              "des": "幾內亞",
              "no": "150507"
            },
            {
              "des": "維德角",
              "no": "150508"
            },
            {
              "des": "甘比亞",
              "no": "150509"
            },
            {
              "des": "獅子山",
              "no": "150510"
            },
            {
              "des": "奈及利亞",
              "no": "150511"
            },
            {
              "des": "賴比瑞亞",
              "no": "150512"
            },
            {
              "des": "象牙海岸",
              "no": "150513"
            },
            {
              "des": "塞內加爾",
              "no": "150514"
            },
            {
              "des": "幾內亞比索",
              "no": "150515"
            },
            {
              "des": "赤道幾內亞",
              "no": "150516"
            },
            {
              "des": "布吉納法索",
              "no": "150517"
            }
          ]
        }
      ]
    },
    {
      "des": "大洋洲",
      "no": "160000",
      "n": [
        {
          "des": "紐澳地區",
          "no": "160100",
          "n": [
            {
              "des": "澳洲",
              "no": "160101"
            },
            {
              "des": "紐西蘭",
              "no": "160102"
            },
            {
              "des": "巴布亞新幾內亞",
              "no": "160103"
            }
          ]
        },
        {
          "des": "大洋洲其它",
          "no": "160200",
          "n": [
            {
              "des": "帛琉",
              "no": "160201"
            },
            {
              "des": "關島",
              "no": "160202"
            },
            {
              "des": "斐濟",
              "no": "160203"
            },
            {
              "des": "諾魯",
              "no": "160204"
            },
            {
              "des": "紐埃",
              "no": "160205"
            },
            {
              "des": "東加",
              "no": "160206"
            },
            {
              "des": "薩摩亞",
              "no": "160207"
            },
            {
              "des": "吐瓦魯",
              "no": "160208"
            },
            {
              "des": "萬那社",
              "no": "160209"
            },
            {
              "des": "庫克群島",
              "no": "160210"
            },
            {
              "des": "吉里巴斯",
              "no": "160211"
            },
            {
              "des": "馬紹爾群島",
              "no": "160212"
            },
            {
              "des": "索羅門群島",
              "no": "160213"
            },
            {
              "des": "密克羅尼西亞",
              "no": "160214"
            },
            {
              "des": "北馬里亞納群島",
              "no": "160215"
            }
          ]
        }
      ]
    }
  ]
};

export const mapping = {};

const parse = (src, root) => {
  src.n?.forEach((item) => parse(item, src.no <= 5));

  mapping[src.no] = src;

  if (root && src.no > 5) {
    items.push(src);
  }

  return src;
};

export const toString = (id) => {
  let parentId = id % 100 ? parseInt(id / 100) * 100 : null;
  let grandparentId = id % 10000 ? parseInt(id / 10000) * 10000 : null;

  switch (parentId) {
  case 130100:
  case 130200:
    grandparentId = null;
    break;
  }

  switch (grandparentId) {
  case 120000:
  case 130000:
  case 140000:
  case 150000:
  case 160000:
    parentId = grandparentId = null;
    break;
  }

  return [mapping[grandparentId]?.des, mapping[parentId]?.des, mapping[id].des].join("");
};

locations.n.forEach((item) => parse(item, true));
